define('TavanoTeamStaging.MadeToOrder.Shopping', [
  'TavanoTeamStaging.MadeToOrder.Shopping.PDP.View'
], function (
  MadeToOrderShoppingPDPView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent('Layout');
      var pdp = container.getComponent('PDP');
      var environment = container.getComponent('Environment');
      var disclaimerMessage = environment.getConfig('TTMadeToOrder.disclaimerMessage');

      if (layout) {
        layout.addChildView('TTMadeToOrder.PDP', function () {
          return new MadeToOrderShoppingPDPView({
            container: container,
            pdp: pdp,
            disclaimerMessage: disclaimerMessage
          });
        });

        // Injecting disclaimer message to the SuiteCommerce Advanced Live/SC_19.2_Live/Commons/Cart/JavaScript/Cart.Lines.View.ts
        // to be used in the ExtensionDevelopmentTools-23.2.0/Workspace/Extras/TavanoTeam_CapitolScientific_Theme/Modules/Cart/Templates/cart_lines.tpl template
        layout.addToViewContextDefinition('Cart.Lines.View', 'ttDisclaimerMessage', 'string', function(context) {
          return disclaimerMessage
        });
      }
    }
  }
});
